import { Configuration, OpenAIApi } from "openai";

const configuration = new Configuration({
  apiKey: process.env.REACT_APP_OPENAI_API_KEY,
});

const openai = new OpenAIApi(configuration);

const SIZES = {
  small: "512x512",
  medium: "1024x1024",
  large: "2048x2048",
};

export const generateImageService = async (prompt, size = "small") => {
  console.log("inside service", prompt, size)
  try {
    const res = await openai.createImage({
      prompt,
      n: 1,
      model: "dall-e-3",
      size: SIZES[size],
      style: "natural",
    });
    return res.data.data[0].url;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const generateDishesCompletion = async (prompt, history) => {
  try {
    const response = await openai.createChatCompletion({
      model: "gpt-4o",
      temperature: 0.89,
      max_tokens: 1000,
      messages: [
        {
          role: "system",
          content: `
                Imagine you are the latest and greatest cooking assistant AI, named Cook-E AI. You are going to be given inputs, in the form of a prompt, and you will then create a response as an object and don't change any keys:
                 Osso Buco alla Milanese**

                dish summary example:"  Originating from Milan, Osso Buco alla Milanese is a traditional Italian dish that consists of cross-cut veal shanks braised with vegetables, white wine, and broth. The dish is slowly cooked until the meat is tender and falls off the bone, creating a rich and flavorful sauce. Olive oil is used to sear the meat and add depth to the sauce, which is traditionally served over creamy risotto or polenta."
  
            {
              "about_dishes":"Italian Dishes with Chicken",
              "about_culture":"Embark on a culinary journey through Italy, where the charm of its cuisine lies in its simplicity, freshness, and regional diversity. Chicken, a versatile ingredient, takes on delectable flavors when combined with traditional Italian herbs, spices, and cooking techniques. Let’s discover three magnificent Italian chicken dishes that are sure to tantalize your taste buds!
              "dishes": [
                {
                  "title": "Title of the dish",
                  "summary": "A  description of the dish focusing on culture and flavor.",
                  "image_prompt": "A detailed, static description for generating an image of the dish, adhering strictly to DALL-E's content policies. Avoid any actions, ambiguous terms, or potentially sensitive descriptions. and give as many details as possible"
                },
                {
                  "title": "Title of the dish",
                  "summary": "A  description of the dish focusing on culture and flavor.",
                  "image_prompt": "A detailed, static description for generating an image of the dish, adhering strictly to DALL-E's content policies. Avoid any actions, ambiguous terms, or potentially sensitive descriptions. and give as many details as possible"
                },
                {
                  "title": "Title of the dish",
                  "summary": "A description of the dish focusing on culture and flavor.",
                  "image_prompt": "A detailed, static description for generating an image of the dish, adhering strictly to DALL-E's content policies. Avoid any actions, ambiguous terms, or potentially sensitive descriptions. and give as many details as possible"
                }
              ]
            }
        
            Provide the response in the specified JSON format only.
                `,
        },
        ...history,
        {
          role: "user",
          content: `${prompt}`,
        },
      ],
    });
    console.log("inside erv==============", response.data.choices[0]?.message?.content,prompt,history)
    return response.data.choices[0]?.message?.content;
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const generateCompletions = async (prompt) => {
  try {
    const response = await openai.createChatCompletion({
      model: "gpt-4o",
      temperature: 0.89,
      max_tokens: 500,
      messages: [
        {
          role: "user",
          content: prompt,
        },
      ],
    });
    return response.data.choices[0].message.content;
  } catch (e) {
    return null;
  }
};
